export const dpcOrder = {
  namespaced: true,
  state:{
    selectedOldPeopleInfo: {},//选择的老人信息
    careWorkInfo:{},//护工信息
    elderOrderList:[],//长者订餐
    careWorkOrderTime:null,//点餐时间
  },
  mutations:{
    set_selected_oldPeople_info(state,data){
      state.selectedOldPeopleInfo=data
    },
    remove_selected_oldPeople_info(state){
      state.selectedOldPeopleInfo={}
    },
    set_careWork_info(state,data){
      state.careWorkInfo=data
    },
    remove_careWork_info(state){
      state.careWorkInfo={}
    },
    set_elder_order_list(state,data){
      state.elderOrderList=data
    },
    remove_elder_order_list(state) {
      state.elderOrderList = []
    },
    set_careWork_order_time(state,data){
      state.careWorkOrderTime=data
    },
    remove_careWork_order_time(state) {
      state.careWorkOrderTime = []
    }
  },
  actions:{

  },

}



// WEBPACK FOOTER //
// ./src/store/modules/dpcOrder.js